import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = () => {
  const alias: any = window.location.pathname.split("/")[1];
  const params: any = window.location.pathname.split("/")[3];
  const schedule: any = window.location.pathname.split("/")[2];
  let user = useSelector((state: any) => state.auth.currentUser);
  
  if (params && schedule === "schedule") {
    localStorage.setItem("path", params);
  }
  
  // Instead of rendering <Route>, we return either <Outlet> or <Navigate>
  return user ? <Outlet /> : <Navigate to={`/${alias}/signin`} replace />;
};

export default PrivateRoute;
